import { render, staticRenderFns } from "./OnMobileComponent.vue?vue&type=template&id=782bf7e7&scoped=true"
import script from "./OnMobileComponent.vue?vue&type=script&lang=js"
export * from "./OnMobileComponent.vue?vue&type=script&lang=js"
import style0 from "./OnMobileComponent.vue?vue&type=style&index=0&id=782bf7e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782bf7e7",
  null
  
)

export default component.exports